import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './planstatus.routes';
import addHtml from './modal/add.html';

export class PlanStatusController {
    $http;
    socket;
    planstatus = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;



        this.planStatus = [
            { value: 0, name: '浏览' },
            { value: 1, name: '订阅' },
            { value: 2, name: '完成' },
        ]





        this.isDisabled = false;
        this.popup2 = {
            opened: false
        };

        this.open2 = function () {
            this.popup2.opened = true;
        };


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('sharelinks');
        });
    }

    TransformationFirstOpen(value) {
        var ret = _.find(this.firstOpen, { value: value });
        if (ret) {
            return ret.name;
        }
        return '';
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/sharelinks/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.sharelinks = response.data.data;
                        this.socket.syncUpdates('sharelinks', this.sharelinks);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }

        const payload = angular.copy(this.filters);
        if (payload && payload.createdAt) {
            payload.createdAt = new Date(payload.createdAt).valueOf();
        }


        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/sharelinks/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.sharelinks = response.data.data;

                        this.socket.syncUpdates('sharelinks', this.sharelinks);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }
}

export default angular.module('tttApp.planstatus', [uiRouter])
    .config(routing)
    .component('planstatus', {
        template: require('./planstatus.html'),
        controller: PlanStatusController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/planstatus/planstatus.component.js